import { IconButton } from '@mui/material'
import { ZoomIn, ZoomOut, Download } from '@mui/icons-material'
import FileSaver from 'file-saver'
import { FileResource } from '../../item/model/FileResource'

export const ViewerToolBar = (
    {
        handleZoomIn,
        handleZoomOut,
        file
    }:{
        handleZoomIn?: () => void | undefined,
        handleZoomOut?: () => void | undefined,
        file: FileResource

    }) => {

        const handleDownloadFile = () => {
            FileSaver.saveAs(file.uri || '', file.name || 'artifact_file')
        }

        return (
            <div className="file-viewer-toolbar">
                {/* Zoom In Button */}
                <IconButton onClick={handleZoomIn} aria-label="Zoom In" disabled={!handleZoomIn}>
                    <ZoomIn />
                </IconButton>

                {/* Zoom Out Button */}
                <IconButton onClick={handleZoomOut} aria-label="Zoom Out" disabled={!handleZoomOut}>
                    <ZoomOut />
                </IconButton>

                {/* Download Button */}
                <IconButton onClick={handleDownloadFile} aria-label="Download File" data-testid="artefact-file-download">
                    <Download />
                </IconButton>
            </div>
        )

}